import $x from '@/utils/$x';

/**
+ * 商品分类列表
+ * @param {*} params
+ * @returns
+ */
export async function getGoodsCategory(params) {
  return $x.post(`/pergamonGoods/queryPhysicalCategories`, params);
}

/**
 * 新增商品
 * @param {*} params
 * @returns
 */
export function addGoods(params) {
  return $x.post('/pergamonGoods/savePhysicalGoods', params);
}

/**
 * 更新商品
 * @param {*} params
 * @returns
 */
export function updateGoods(params) {
  return $x.post('/pergamonGoods/updatePhysicalGoods', params);
}

/**
 * 查询商品
 * @param {*} params
 * @returns
 */
export function queryGoods(params) {
  return $x.post('/pergamonGoods/queryPhysicalGoodsById', params);
}

///以下会员接口
/**
 * 保存会员商品
 * @param {*} params
 * @returns
 */
export function saveVipGoods(params) {
  return $x.post('/pergamonGoods/saveLittaGoodsInfo', params);
}

/**
 * 保存会员商品
 * @param {*} params
 * @returns
 */
export function updateVipGoods(params) {
  return $x.post('/pergamonGoods/updateLittaGoodsInfo', params);
}

/**
 * 根据id查询会员商品详情
 * @param {*} params
 * @returns
 */
export function queryLittaGoodsInfoById(params) {
  return $x.post('/pergamonGoods/queryLittaGoodsInfoByIdCondition', params);
}

/**
 * 新增套餐商品
 * @param {*} params
 * @returns
 */
export function savePackageGoods(params) {
  return $x.post('/pergamonGoods/saveLittaCombineGoodsRel', params);
}

/**
 * 更新套餐商品
 * @param {*} params
 * @returns
 */
export function updatePackageGoods(params) {
  return $x.post('/pergamonGoods/updateLittaCombineGoodsRel', params);
}

/**
 * 查询价签列表
 * @param {*} params
 * @returns
 */
export function queryPriceTagList(params) {
  return $x.post('/pergamonGoods/queryPriceTagList', params);
}
